export const SettingsPages = {
  companyProfile: "company-profile",
  thirdPartyIntegration: "third-party-integration",
  billing: "billing",
  customFloorPlans: "custom-floor-plans",
  sso: "sso",
  customBranding: "custom-branding",
} as const;
